/**
 * Category Internationalization Map
 * Maps category keys to localized labels (EN/AR)
 * Used across Ladies Hub and main marketplace
 * 
 * SINGLE SOURCE OF TRUTH for all category translations
 */

export const CATEGORY_I18N = {
  // ==========================================
  // Ladies Hub Categories (Primary)
  // ==========================================
  sudanese_thobes: { en: "Sudanese Thobes", ar: "الثياب السودانية" },
  occasion_dresses: { en: "Occasion Dresses", ar: "فساتين مناسبات" },
  religious_clothing: { en: "Religious Clothing", ar: "ملابس دينية" },
  shoes: { en: "Shoes", ar: "أحذية" },
  bags: { en: "Bags", ar: "شنط" },
  medical_products: { en: "Medical Products", ar: "مستحضرات طبية" },
  salon: { en: "Salon Services", ar: "صالون" },
  perfumes: { en: "Perfumes", ar: "عطور" },
  accessories: { en: "Accessories", ar: "إكسسوارات" },
  handmade: { en: "Handmade", ar: "أعمال يدوية" },
  
  // Ladies Hub Categories (Extended)
  jewellery: { en: "Jewellery", ar: "المجوهرات" },
  jewelry: { en: "Jewellery", ar: "المجوهرات" },
  gold: { en: "Gold", ar: "الذهب" },
  gold_jewelry: { en: "Gold & Jewellery", ar: "الذهب والمجوهرات" },
  henna: { en: "Henna", ar: "الحنّة" },
  fashion: { en: "Fashion", ar: "الأزياء" },
  beauty: { en: "Beauty", ar: "الجمال" },
  bags_accessories: { en: "Bags & Accessories", ar: "الشنط والإكسسوارات" },
  abayas: { en: "Abayas", ar: "العبايات" },
  dresses: { en: "Dresses", ar: "فساتين" },
  dresses_sets: { en: "Dresses & Sets", ar: "فساتين وأطقم" },
  makeup: { en: "Makeup", ar: "المكياج" },
  makeup_offers: { en: "Makeup Offers", ar: "عروض مكياج" },
  beauty_services: { en: "Beauty Services", ar: "خدمات التجميل" },
  womens_shoes: { en: "Women's Shoes", ar: "أحذية نسائية" },
  events: { en: "Events", ar: "المناسبات" },
  handmade_culture: { en: "Handmade & Culture", ar: "الأشغال اليدوية والثقافة" },
  skincare: { en: "Skincare", ar: "العناية بالبشرة" },
  haircare: { en: "Haircare", ar: "العناية بالشعر" },
  watches: { en: "Watches", ar: "الساعات" },
  
  // ==========================================
  // Main Marketplace Categories
  // ==========================================
  all: { en: "All", ar: "الكل" },
  vehicles: { en: "Vehicles & Motorbikes", ar: "المركبات والدراجات النارية" },
  spare_parts: { en: "Vehicle Spare Parts & Accessories", ar: "قطع غيار وإكسسوارات المركبات" },
  electronics: { en: "Electronics & Accessories", ar: "الإلكترونيات والإكسسوارات" },
  industrial: { en: "Industrial Machinery", ar: "الآلات الصناعية" },
  equipment: { en: "Equipment & Tools", ar: "المعدات والأدوات" },
  real_estate: { en: "Real Estate", ar: "العقارات" },
  agriculture: { en: "Agriculture", ar: "الزراعة" },
  food: { en: "Food & Beverages", ar: "الأغذية والمشروبات" },
  gifts: { en: "Gifts & Crafts", ar: "الهدايا والحرف" },
  pets: { en: "Pets & Livestock", ar: "الحيوانات الأليفة والماشية" },
  metals: { en: "Metals & Alloys", ar: "المعادن والسبائك" },
  fabrics: { en: "Fabrics & Raw Materials", ar: "الأقمشة والمواد الخام" },
  garden: { en: "Garden & Decorations", ar: "الحدائق والديكور" },
  it: { en: "IT Equipment & Software Services", ar: "معدات تقنية المعلومات وخدمات البرمجيات" },
  manufacturing: { en: "Manufacturing", ar: "التصنيع" },
  jobs: { en: "Jobs", ar: "وظائف" },
  medical: { en: "Medical Devices", ar: "الأجهزة الطبية" },
  security: { en: "Security & Safety", ar: "الأمن والسلامة" },
  energy: { en: "Energy", ar: "الطاقة" },
  services: { en: "Services", ar: "الخدمات" },
  home: { en: "Home Supplies", ar: "مستلزمات المنزل" },
  furniture: { en: "Furniture", ar: "الأثاث" },
  office: { en: "Office & School Supplies", ar: "مستلزمات المكاتب والمدارس" },
  apparel: { en: "Apparel & Accessories", ar: "الملابس والإكسسوارات" },
  environment: { en: "Environment", ar: "البيئة" },
  commodities: { en: "Commodities", ar: "السلع" },
  
  // Extended marketplace categories
  mobile: { en: "Mobile & Accessories", ar: "الموبايلات والإكسسوارات" },
  mobile_accessories: { en: "Mobile & Accessories", ar: "الموبايلات والإكسسوارات" },
  laptops: { en: "Laptops & Accessories", ar: "اللابتوبات والإكسسوارات" },
  laptops_accessories: { en: "Laptops & Accessories", ar: "اللابتوبات والإكسسوارات" },
  clothes: { en: "Clothes & Shoes", ar: "الملابس والأحذية" },
  clothes_shoes: { en: "Clothes & Shoes", ar: "الملابس والأحذية" },
  sports: { en: "Sports Equipment & Supplies", ar: "معدات ولوازم الرياضة" },
  sports_equipment: { en: "Sports Equipment & Supplies", ar: "معدات ولوازم الرياضة" },
  health: { en: "Health & Fitness", ar: "الصحة واللياقة" },
  health_fitness: { en: "Health & Fitness", ar: "الصحة واللياقة" },
  games: { en: "Games & Toys", ar: "الألعاب والدمى" },
  games_toys: { en: "Games & Toys", ar: "الألعاب والدمى" },
  cars: { en: "Cars", ar: "السيارات" },
  
  // ==========================================
  // Hub Types
  // ==========================================
  ladies: { en: "Ladies Hub", ar: "قسم السيدات" },
  ladies_hub: { en: "Ladies Hub", ar: "قسم السيدات" },
  students: { en: "Students", ar: "الطلاب" },
  students_hub: { en: "Students Hub", ar: "قسم الطلاب" },
  farm: { en: "Farm", ar: "المزرعة" },
  farmers_hub: { en: "Farmers Hub", ar: "قسم المزارعين" },
  booking: { en: "Booking", ar: "الحجز" },
  
  // ==========================================
  // Fallback
  // ==========================================
  uncategorized: { en: "Uncategorized", ar: "غير مصنف" },
  other: { en: "Other", ar: "أخرى" },
};

/**
 * Location/City Translations
 */
export const LOCATION_I18N = {
  khartoum: { en: "Khartoum", ar: "الخرطوم" },
  omdurman: { en: "Omdurman", ar: "أم درمان" },
  bahri: { en: "Bahri", ar: "بحري" },
  port_sudan: { en: "Port Sudan", ar: "بورتسودان" },
  kassala: { en: "Kassala", ar: "كسلا" },
  gedaref: { en: "Gedaref", ar: "القضارف" },
  wad_madani: { en: "Wad Madani", ar: "ود مدني" },
  nyala: { en: "Nyala", ar: "نيالا" },
  el_fasher: { en: "El Fasher", ar: "الفاشر" },
  dongola: { en: "Dongola", ar: "دنقلا" },
  atbara: { en: "Atbara", ar: "عطبرة" },
  sennar: { en: "Sennar", ar: "سنار" },
  el_obeid: { en: "El Obeid", ar: "الأبيض" },
  sudan: { en: "Sudan", ar: "السودان" },
};

/**
 * Normalize category key for lookup
 * Handles variations like snake_case, spaces, path-style categories, etc.
 */
export function normalizeCategoryKey(key) {
  if (!key) return '';
  return key.toLowerCase().trim().replace(/[\s-]+/g, '_');
}

/**
 * Extract the most specific category from a path-style category
 * e.g., "ladies/fashion/shoes" -> "shoes"
 * e.g., "electronics" -> "electronics"
 */
export function extractCategoryFromPath(categoryPath) {
  if (!categoryPath) return '';
  
  // Handle path-style categories (e.g., "ladies/fashion/shoes")
  if (categoryPath.includes('/')) {
    const segments = categoryPath.split('/').filter(Boolean);
    // Return the last (most specific) segment
    return segments[segments.length - 1] || '';
  }
  
  return categoryPath;
}

/**
 * Get localized category label
 * @param {string} categoryKey - The category key (e.g., "sudanese_thobes", "electronics", "ladies/fashion/shoes")
 * @param {string} lang - Language code ('ar' | 'en')
 * @returns {string} Localized category label
 */
export function getCategoryLabel(categoryKey, lang = 'ar') {
  if (!categoryKey) return '';
  
  // Extract the most specific category from path-style keys
  const extractedCategory = extractCategoryFromPath(categoryKey);
  const normalizedKey = normalizeCategoryKey(extractedCategory);
  const entry = CATEGORY_I18N[normalizedKey];
  
  if (entry) {
    return lang === 'ar' || lang?.startsWith('ar') ? entry.ar : entry.en;
  }
  
  // Try looking up the full path as well (for cases where full path is a key)
  const fullPathNormalized = normalizeCategoryKey(categoryKey.replace(/\//g, '_'));
  const fullPathEntry = CATEGORY_I18N[fullPathNormalized];
  if (fullPathEntry) {
    return lang === 'ar' || lang?.startsWith('ar') ? fullPathEntry.ar : fullPathEntry.en;
  }
  
  // Fallback: convert snake_case to Title Case
  return extractedCategory
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Check if language is Arabic
 * @param {string} lang - Language code
 * @returns {boolean}
 */
export function isArabicLang(lang) {
  return (lang || "").toLowerCase().startsWith("ar");
}

/**
 * Translate category to localized label (alias for getCategoryLabel)
 * @param {string} categoryRaw - Raw category from DB (key/slug)
 * @param {string} lang - Language code ('en' or 'ar')
 * @returns {string} Localized category label
 */
export function tCategory(categoryRaw, lang) {
  return getCategoryLabel(categoryRaw, lang);
}

/**
 * Get category label from ad object with fallback.
 *
 * iter268: prefer the canonical `category_label` block populated by the
 * backend `_project_canonical_category` projector. That block carries
 * both parent + sub labels in EN and AR, so we can render
 * "Vehicles & Motorbikes · Cars" when a sub is present.
 *
 * @param {object} ad   - Ad object (may carry category, category_id, category_label)
 * @param {string} lang - 'en' | 'ar'
 * @returns {string} Best available category label (parent · sub when applicable)
 */
export function getAdCategoryLabel(ad, lang) {
  if (!ad) return "";

  // 1) Canonical block from backend — preferred.
  const cl = ad.category_label;
  if (cl && typeof cl === 'object') {
    const ar = isArabicLang(lang);
    const parent = ar ? (cl.parent_ar || cl.parent_en) : (cl.parent_en || cl.parent_ar);
    const sub = cl.sub_id
      ? (ar ? (cl.sub_ar || cl.sub_en) : (cl.sub_en || cl.sub_ar))
      : null;
    if (parent && sub) return `${parent} · ${sub}`;
    if (parent) return parent;
  } else if (typeof cl === 'string' && cl) {
    return cl;
  }

  // 2) Fallback: read the canonical fields directly.
  const parentKey = ad.category;
  const subKey = ad.subcategory;
  if (parentKey || subKey) {
    const parent = parentKey ? getCategoryLabel(parentKey, lang) : '';
    if (parent && subKey) {
      // Sub labels are not always in CATEGORY_I18N; humanise as fallback.
      const subHuman = getCategoryLabel(subKey, lang);
      const subLabel = subHuman || subKey.replace(/_/g, ' ');
      return `${parent} · ${subLabel}`;
    }
    if (parent) return parent;
  }

  // 3) Final fallback: legacy fields.
  const categoryKey = ad.category_id || ad.category;
  return getCategoryLabel(categoryKey, lang);
}

export default CATEGORY_I18N;
